import { render, staticRenderFns } from "./AttributeSelection.vue?vue&type=template&id=b8d02d9c&scoped=true&"
import script from "./AttributeSelection.vue?vue&type=script&lang=js&"
export * from "./AttributeSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d02d9c",
  null
  
)

export default component.exports